import React, { useContext } from 'react';
import { AuthContext } from '../store';
import PuffLoader from 'react-spinners/PuffLoader';

const withSpinner = (WrappedComponent) => (props) => {
    const { isLoading, started } = useContext(AuthContext);
    return isLoading || !started ? (
        <PuffLoader
            css={{ position: 'absolute', top: '50%', left: '50%', transform: 'translateX(-50%) translateY(-50%)' }}
            color={'#ffcc2e'}
            size={150}
            loading={true}
        />
    ) : (
        <WrappedComponent {...props} />
    );
};

export default withSpinner;
